export default __webpack_public_path__ + "static/media/award-2.7efc1bba.png";